function useFormateDate(dateString) {
	const now = new Date()
	const past = new Date(dateString)
	const diffMs = now - past

	const minute = 60 * 1000
	const hour = 60 * minute
	const day = 24 * hour
	const month = 30 * day
	const year = 365 * day

	if (diffMs < minute) return "Just now"
	if (diffMs < hour) {
		const mins = Math.floor(diffMs / minute)
		return `${mins} minute${mins !== 1 ? "s" : ""} ago`
	}
	if (diffMs < day) {
		const hrs = Math.floor(diffMs / hour)
		return `${hrs} hour${hrs !== 1 ? "s" : ""} ago`
	}
	if (diffMs < month) {
		const days = Math.floor(diffMs / day)
		return `${days} day${days !== 1 ? "s" : ""} ago`
	}
	if (diffMs < year) {
		const months = Math.floor(diffMs / month)
		return `${months} month${months !== 1 ? "s" : ""} ago`
	}
	const years = Math.floor(diffMs / year)
	return `${years} year${years !== 1 ? "s" : ""} ago`
}

export default useFormateDate
